import React from 'react';

const usePageMetadata = (title: string, description: string) => {
  React.useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    const meta = document.querySelector('meta[name="description"]');
    const previous = meta?.getAttribute('content');
    meta?.setAttribute('content', description);
    return () => {
      document.title = previousTitle;
      if (previous) meta?.setAttribute('content', previous);
    };
  }, [title, description]);
};

export default usePageMetadata;
